import React from "react";
import "./Header.css";
import { ConnectButton } from "@rainbow-me/rainbowkit";

const Header = ({
  account,
  contract,
  setView,
  view,
  isOwner,
  isPaused,
  handleEmergencyWithdraw,
}) => {
  return (
    <header className="header">
      {isOwner ? (
        <>
          {view === "dashboard" ? (
            <>
              <a href="#" onClick={() => setView("owner")}>
                Dashboard
              </a>
            </>
          ) : (
            <>
              <a href="#" onClick={() => setView("dashboard")}>
                Owner Dashboard
              </a>
            </>
          )}
        </>
      ) : (
        <h1>Dashboard</h1>
      )}
      <div className="header-btns">
        <button
          className="eme-wid-btn"
          onClick={() => {
            isPaused
              ? handleEmergencyWithdraw()
              : alert("Contract is not Paused!");
          }}
        >
          Emergency Withdrawal
        </button>
        <ConnectButton accountStatus="address" size="24px" />
      </div>
    </header>
  );
};

export default Header;
